const utils = {
	storage_string: {
		conversion_failed: "Konvertierung von Bytes fehlgeschlagen",
	},
};

export default utils;
